const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const mobileMenu = $("header[role='banner'].site-header");

function throttle(fn, wait) {
  let time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}

function toggleMobileMenu() {
  const button = $(`.site-header [aria-controls="primary-nav"]`);
  const state = button.getAttribute("aria-expanded");
  const isOpen = state === "true";
  const mobileMenu = $("header[role='banner'].site-header");

  button.setAttribute("aria-expanded", isOpen ? "false" : "true");
  button.innerText = isOpen ? "Menu" : "Close";
  mobileMenu.classList.toggle("menu-open");
  $("body").classList.toggle("overflow-hidden");
}

function openSubnav(parent) {
  const button = $("button", parent);

  parent?.classList.add("open");
  button?.setAttribute(`aria-expanded`, `true`);
}

function closeSubnav(parent) {
  const button = $("button", parent);

  parent?.classList.remove("open");
  button?.setAttribute(`aria-expanded`, `false`);
}

function closeSubnavs() {
  const openMenus = $$(".site-header .isParent.open, .site-header .isGrandParent.open");
  openMenus.forEach(function(menu) {
    closeSubnav(menu);
  })
}

// $(".search-toggle").addEventListener("click", function(event) {
//   $("header nav[aria-label='Utility'] form[role='search'] input.search-field").focus();
// });

document.addEventListener("click", function(event) {
  const button = event.target.closest(`.site-header [aria-controls="primary-nav"]`);
  if (!button) {
    return;
  }

  toggleMobileMenu();
});

document.addEventListener('touchend', function (event) {
  let closest = event.target.closest(".site-header:not(.menu-open) .isParent > a, .site-header:not(.menu-open) .isGrandParent > a");
  if ($(".site-header.menu-open")) {
    return;
  }
  
  if (closest) {
    let parent = closest.parentNode;
    if (parent.classList.contains("open")) return;
    closeSubnavs();
    openSubnav(parent);
  } else {
    const inMenu = event.target.closest("li.open");
    if (!inMenu) {
      closeSubnavs();
    }
    return;
  }
  event.preventDefault();
}, false);

document.addEventListener('mouseover', function (event) {
  let closest = event.target.closest(".site-header:not(.menu-open) nav#primary-nav > ul > .isParent, .site-header:not(.menu-open) nav#primary-nav > ul > .isGrandParent");
  if (!closest) return;
  openSubnav(closest);
}, false);

document.addEventListener('mouseout', function (event) {
  let closest = event.target.closest(".site-header:not(.menu-open) nav#primary-nav > ul > .isParent, .site-header:not(.menu-open) nav#primary-nav > ul > .isGrandParent");
  if (!closest) return;
  closeSubnav(closest);
}, false);

document.addEventListener('click', function (event) {
  let closest = event.target.closest(".site-header:not(.menu-open) #primary-nav a + button");
  if (!closest) return;

  let $toggle = closest;
  let $navItem = $toggle.closest(`li`);
  let $otherNavItems = Array.prototype.filter.call($navItem.parentNode.children, function(child){
    return child !== $navItem;
  });

  $otherNavItems.forEach(item => {
    closeSubnav(item);
  })

  if ($navItem.classList.contains("open")) {
    closeSubnav($navItem);
  } else {
    openSubnav($navItem);
  }
}, false);

document.addEventListener('click', function (event) {
  const targets = `
    .site-header.menu-open #primary-nav > ul > .isParent > a,
    .site-header.menu-open #primary-nav > ul > .isParent > button,
    .site-header.menu-open #primary-nav > ul > .isGrandParent > a,
    .site-header.menu-open #primary-nav > ul > .isGrandParent > button
  `
  const closest = event.target.closest(targets);
  if (!closest) return;

  const $navItem = closest.parentNode;
  let siblings = Array.prototype.filter.call($navItem.parentNode.children, function(child){
    return child !== $navItem;
  });

  event.preventDefault();

  if ($navItem.classList.contains(`open`)) {
    closeSubnav($navItem);
    $(".site-header").classList.remove("submenu-open");
  } else {
    openSubnav($navItem);
    siblings.forEach(sibling => {
      closeSubnav(sibling);
    })
    $(".site-header").classList.add("submenu-open");
  }
}, false);

// header class on hover
const header = document.querySelector('header.site-header');

header.addEventListener('mouseover', () => {
  header.classList.add('hovered');
});
header.addEventListener('mouseout', () => {
  header.classList.remove('hovered');
});

let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

function setHeaderHeight() {
  const headerHeight = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

let callResize;
window.onresize = function(){
  clearTimeout(callResize);
  callResize = setTimeout(setHeaderHeight, 100);
};
setHeaderHeight();

let scrollCallback = function(){
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let diff = Math.abs(lastScrollTop - scrollTop);

  if (!header.classList.contains("menu-open")) {
    if (scrollTop > lastScrollTop){
      if (header.classList.contains("unfold") && diff > 10) {
        header.classList.remove("unfold");
      }
    } else {
      if (!header.classList.contains("unfold") && diff > 10 && document.documentElement.scrollTop > 500) {
        const headerHeight = header.offsetHeight;
        header.classList.add("unfold");
      } else if (header.classList.contains("unfold") && document.documentElement.scrollTop <= 500) {
        header.classList.remove("unfold");
      }
    }
  }

  if (diff > 10) {
    lastScrollTop = scrollTop<= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }
}

window.addEventListener("scroll", throttle(scrollCallback, 25) , false);